var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchCommune(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 441.536,
    height: 334.067,
    viewBox: "0 0 441.536 334.067",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_88",
    "data-name": "Rectangle 88",
    width: 434.967,
    height: 334.067,
    fill: "none",
    stroke: "#f3ede3",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2567",
    "data-name": "Groupe 2567",
    transform: "translate(-824.142 -1376.967)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2490",
    "data-name": "Groupe 2490",
    transform: "translate(824.142 1376.968)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2489",
    "data-name": "Groupe 2489",
    transform: "translate(0 -0.001)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_839",
    "data-name": "Trac\\xE9 839",
    d: "M417.233,142.094c4.4.044,9.031-1.29,13.858-1.055-.869,6.719-4.3,6.919-8.866,11.334-3.566,3.445-.624,2.577-.361,6.253.114,1.613-2.853,5.266-3.739,6.487-3.015,4.157-7.8,7.046-11.828,10.377-4.841,4.007-5.293,8.657-7.124,14.029-2.819,8.279-10.235,10.741-17.987,13.838-4.338,1.733-7.206,2.14-8.351,7.148-1.039,4.543.021,10.628.021,15.313,0,4.97.3,7.628-3.178,11.1-2.937,2.931-5.362,6.286-8.316,9-2.848,2.615-6.06,4.266-8.761,7.061-2.843,2.942-12.012,10.064-12.256,14.227,1.006.383,2.41-.043,3.378.434,1.267.845.845,3.8.845,4.644-.422,2.534-3.378,4.222-5.066,5.489a8.554,8.554,0,0,0-2.533,6.755,21.44,21.44,0,0,1-1.267,7.178c-2.058,6.174-8.8,8.683-12.139,13.616-1.154,1.7-.826,3.283-1.9,4.971-1.286,2.02-2.462,1.806-4.537,2.97-1.273.715-3.462,2.539-4.646,2.951-2.134.742-9.563.512-11.22-.938-3.392-2.966-1.783-10.559-9.158-8.79-3.33.8-15.357,17.057-17.2,7.092-.335-1.816,1.26-4.264.592-5.509-.767-1.426-4.722-2.65-6.173-4.013-3.513-3.3-5.716-7.619-9.1-11.083-2.974-3.04-5.621-3.36-8.939-5.573-2.792-1.864-6.015-7.763-9.31-8.172-4.268-.529-5.04,5.348-9.383,5.31-4.56-.04-5.781-4.972-10.78-4.664-8.486.522-9.685,16.032-11.492,22.441-1.084,3.848-2.192,7.905-3.389,11.766-1.062,3.43-.427,7.056-1.667,10.526-.94,2.628-2.291,4.381-2.619,7.146-8.631,1.385-5.794-9.345-7.295-13.449-.6-1.649-4.46-5.435-6.236-5.529-3.99-.213-3.6,3.594-5.065,6.312-3.963.226-7.018.134-10.46-2.13-2.111-1.39-3.716-4.144-6.78-3.3-7.946,2.18-2.162,10.647-3.515,14.723-4.555,1.3-8.789,4.462-13.384,5.152-4.425.664-9.045-.508-13.272-1.383-5.776-1.2-8.187-.289-12.874,1.394-4.862,1.746-7.026-1.143-10.473-4.383-2.9-2.723-5.962-5.938-4.321-10.542,1.24-3.476,5.815-4.666,8.029-7.579,3.394-4.467,4.989-17.793.856-22.375-2.815-3.121-5.6-.569-8.771-1.989-1.809-.813-1.283-2.672-3.168-3.769-1.245-.723-3.506-.293-4.94-.484-10.339-1.378-5.759-9.7-10.082-16.605-2.914-4.652-4.986-15.714-10.615-18.236-5.258-2.356-8.751,7.851-10.793,11.429-.929,1.626-1.387,5.272-4.145,4.07-2.052-.895-1.834-4.865-.9-6.4-6.2-.864-12.546-2.022-18.832-1.591q-4.119,3.485-9.683.175A69.412,69.412,0,0,1,19.3,247.38c-2.26-4.919,3.863-7.687,4.384-12.673.52-4.964-3.1-8.273-2.533-13.511.487-4.49,4.819-9.62,2.555-14.283-.99-2.034-4.153-2.763-5.1-4.7-1.94-3.976.429-9.342-.8-13.7-1.508-5.357-5.36-9.793-5.951-15.456-.5-4.858-.054-4.793-4.117-8.01C5.151,163-.661,159.59.409,155.765c.91-3.255,6.581-4.988,7.567-9.3.978-4.272-1.506-6.309-3.7-9.49-1.8-2.61-4.842-6.022-3.417-9.191,1.842-4.088,6.007-2.218,8.359-4.558,2.409-2.4.543-8.8-.813-11.466-.976-1.92-1.933-4.736-3.181-6.367C3.86,103.618,1.5,102.969.578,100.781c-2.607-6.17,4.252-4.724,7.915-6.239,2.857-1.181,5.754-3.8,8.362-5.574.112-1.773.684-4.99.1-6.678-.7-2.048-3.393-3.034-3.017-5.479.4-2.616,5.649-4.615,7.523-6.462,6.033-5.948,5.576-12.386.425-19.213-2.934-3.888-2.928-7.727-5.684-11.452-1.7-2.3-9.683-6.428-9.749-9.034-.033-1.326,8.781-6.739,10.054-8.749,2.8-4.416-1.473-3.488-.861-8.446A16.7,16.7,0,0,1,19.84,4.928c3.058-3.123,5.146-2.422,9.512-2.185,5.029.272,11.853,1.727,16.74.2.927-.289,1.788-2.255,2.586-2.5,6.787-2.1,13.292,3.793,17.791,7.8,2.02,1.8,4.3,3.279,6.328,5.071,4.793,4.234,3.4,4.433,1.976,9.449-.462,1.623-.208,4.717,0,6.4.477,3.861,4.537,10.32,9.709,8.792,2.169-.64,1.628-3.332,3.345-3.825,2-.575,5.284,3.741,6.365,5.072,3.765,4.638,1.58,8.333,3.043,13.533,1.146,4.074,5.667,7.149,8.451,10.017,4.019,4.14,7.2,3.362,12.9,3.917,4.623.449,7.112.8,10.946-1.781,3.967-2.668,5.591-4.32,9.1.575,1.522,2.126,1.547,5.366,5.085,4.614,2.32-.493,2.362-3.719,3.666-5.013,5.316-5.268,15.035.136,20.275-6.323,3.846-4.741,3.16-6.417,10.148-6.427,5.089-.007,8.467.664,12.612,2.911,8.875,4.81,12.523,13.035,19.813,19.828,1.852,1.726,5.418,4.595,4.746,7.546-.9,3.968-8.381,3.463-6.909,7.324.2.527,3.719,2.572,4.44,3.262,2.218,2.124,1.465.944,2.439,4.41.875,3.107-.547,2.808,2.956,3.7,1.948.494,4.1-.608,5.806.508,3.551,2.321,3.424,7.091,9.076,5.527,2.784-.77.584-3.012,3.788-1.483,1.835.875,3.214,4.15,4.946,5.584,3.353,2.777,7.935,5.89,12.365,3.89,4.011-1.81,3.841-6.883,5.179-9.728,2.154-4.58,7.864-7.812,12.83-5.595.561.25-.46,2.08.427,2.5s2.8.109,3.765.064c3.2-.148,2.675-.721,5.152-2.133,3.65-2.081,7.435-3.676,6.754-8.772-.452-3.39-5.237-6.887-2.141-10.44,1.2-1.374,4.217-.811,5.507-1.869,2.678-2.2,1.621-2.953,5.342-3.81,5.169-1.19,4.666.659,6.49-3.913.8-2.009,1.519-3.734,2.533-5.8,1.62-3.3,2.541-10.592,6.735-10.983,3.144-.293,1.7,2.788,5.306,1.293.93-.385,3.233-3.184,4.026-4.03a15.235,15.235,0,0,0,3.432-4.784c3.731-.236,6.178-.921,7.977,2.46,1.756,3.3-.1,6.046,4.021,8.855,7.857,5.362,11.2-2.91,17.791-3.788,4.442-.592,7.607.871,9.8,4.215,1.661,2.527,2.524,8.288,6.776,5.081,3.925-2.961,4.007-7.376,10.636-5.494,4.66,1.323,8.146,5.885,11.639,8.957,3.353,2.948,7.629,3.976,10.963,6.722,3.922,3.232,4.216,5.456,9.828,5.429,11.662-.056,13.405,7.937,12.246,18.157-.135,1.194-1.009,3.693-.868,4.621.641,4.2,1.661,1.622,4.7,3.4,2.86,1.674,3.4,5.51,3.759,9.259.607,6.364,1.545,6.775-3.79,9.543-3.632,1.885-5.352,5.474-8.179,8.183-3.215,3.079-5.675,4.073-5.289,9.178",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#f3ede3",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2513",
    "data-name": "Groupe 2513",
    transform: "translate(804.082 1331.02)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2514",
    "data-name": "Groupe 2514",
    transform: "translate(42.203 135.972)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_847",
    "data-name": "Trac\\xE9 847",
    d: "M29.119,274.17C31.291,272,169.356,151.093,310.777,148.134",
    transform: "translate(66.046 -51.949)",
    fill: "none",
    stroke: "#f3ede3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.35
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_848",
    "data-name": "Trac\\xE9 848",
    d: "M188.062,198.313c-1.776-1.776-93.62-42.461-177.826-47.922",
    transform: "translate(-10.249 -35.408)",
    fill: "none",
    stroke: "#f3ede3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.35
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_864",
    "data-name": "Trac\\xE9 864",
    d: "M155.331,190.754c-1.449-1.5-76.388-35.763-145.095-40.364",
    transform: "translate(-7.518 -9.463)",
    fill: "none",
    stroke: "#f3ede3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.35
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_851",
    "data-name": "Trac\\xE9 851",
    d: "M270.389,208.926c-23-24.548-178.088-92.307-290.514-81.656",
    transform: "translate(8.184 -94.401)",
    fill: "none",
    stroke: "#f3ede3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.35
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_852",
    "data-name": "Trac\\xE9 852",
    d: "M86.09,196.407c1.867-.931,111.553-42.228,167.083-93.207",
    transform: "translate(148.727 -110.202)",
    fill: "none",
    stroke: "#f3ede3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.35
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_853",
    "data-name": "Trac\\xE9 853",
    d: "M91.62,189.409c1.867-.931,99.26-37.026,146.6-80.722",
    transform: "translate(172.786 -87.014)",
    fill: "none",
    stroke: "#f3ede3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.35
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_863",
    "data-name": "Trac\\xE9 863",
    d: "M90.367,190.836c1.867-.931,20.388-8.963,61.809-34",
    transform: "translate(246.084 -91.014)",
    fill: "none",
    stroke: "#f3ede3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.35
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_854",
    "data-name": "Trac\\xE9 854",
    d: "M80.225,180.793c4.109,0,145.664-61.5,172.064-92.446",
    transform: "translate(123.212 -107.183)",
    fill: "none",
    stroke: "#f3ede3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.35
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_857",
    "data-name": "Trac\\xE9 857",
    d: "M-8.145,136.444c65.382-4.821,181.774,11,256.08,66.638",
    transform: "translate(-8.53 -73.99)",
    fill: "none",
    stroke: "#f3ede3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.35
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_858",
    "data-name": "Trac\\xE9 858",
    d: "M-2.472,141.141c79.2,4.552,148.2,22.1,218.025,58.262",
    transform: "translate(-6.19 -53.924)",
    fill: "none",
    stroke: "#f3ede3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.35
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_859",
    "data-name": "Trac\\xE9 859",
    d: "M60.351,259.606s95.267-88.166,208.876-98.817",
    transform: "translate(80.968 -35.609)",
    fill: "none",
    stroke: "#f3ede3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.35
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_860",
    "data-name": "Trac\\xE9 860",
    d: "M133.509,216.345s63.7-41.066,116.15-45.866",
    transform: "translate(95.148 -20.553)",
    fill: "none",
    stroke: "#f3ede3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.35
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_862",
    "data-name": "Trac\\xE9 862",
    d: "M133.509,216.345s32.169-22.851,73.134-31.6",
    transform: "translate(115.148 -1.553)",
    fill: "none",
    stroke: "#f3ede3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.35
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_861",
    "data-name": "Trac\\xE9 861",
    d: "M106.627,167.629c21.3-11.322,26.822-23.879,16.335-30.872s4.307,35.763,29.647,8.234",
    transform: "translate(1054.348 1341.295) rotate(-25)",
    fill: "none",
    stroke: "#f3ede3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.35
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchCommune);
export default __webpack_public_path__ + "static/media/search-commune.177623ea1229a05ed72807951f8fd34a.svg";
export { ForwardRef as ReactComponent };